export interface GroupQuestions {
    id: number,
    name?: string,
    questions: number[],
}

export const commonQuestionsGroups: GroupQuestions[] = [{
    id: 1,
    questions: [1],
},{
    id: 2,
    questions: [2,3,4,5,6,7,8],
},{
    id: 3,
    questions: [9,10,11],
},{
    id: 4,
    questions: [12],
},{
    id: 5,
    questions: [14],
},{
    id: 6,
    questions: [15],
},{
    id: 7,
    questions: [16,17,18],
},];

export const instructorsQuestionsGroups: GroupQuestions[] = [{
    id: 8,
    questions: [19],
},{
    id: 9,
    questions: [20,21,22,23,24,25,26,27,28,29,30],
},{
    id: 10,
    questions: [31,32,33,34],
},{
    id: 11,
    questions: [35,36,37,38,39,40,41,42,43],
}];